module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAlBAMAAADYclYOAAAAJ1BMVEVHcEz///////////////////////////////////////////////8NopmKAAAADHRSTlMA7zgZCNZjjsi0pUaWOhvAAAABGElEQVQoz13SLU/EQBAG4El7AYE7d+kJGsAhakhOXnBoHDmBQCBBgMJhK0kwiBOHQ0CCwiGW3MH7o5iv3Q5M0o9sn7yznZboY06xbomq6UNc2cY5tfiO7A4/fGAZEdbUI7JrIInCKiBWLZ83QxI4a2c6MEHckd5Q0gR9zWVjmSm6kLs2M0XKj53lJClJ23T1gMiant2UJBpZmpajy86aWtLokWgLp4UxOsEVHWJdGKMnXn8B7p0p4knwcDJT5MMxZojHcgRji2QIY743Vu0Z+nwnOuBr6nTTvSKiujfmaFeeeVpOkqo9TdG+vbew9FpJQOPDUZYWOakwraZ8Y20aEZezcfhfNC2385r9R5YWkzyt+btC9fMko1/8aeap56YuEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.png
// module id = edSy
// module chunks = 1